import { detect } from 'detect-browser';

export function isSupportedSlateBrowser() {
  const userAgent = window.navigator.userAgent;
  // When testing, the user agent string can retain its surrounding quotation marks which need to be
  // stripped in order for the detect function to work properly
  const formattedUserAgent = userAgent.replace(/['"]+/g, '');

  const browser = detect(formattedUserAgent);
  const browserVersion = browser.version;
  const formattedBrowserVersion = Number(browserVersion.split('.')[0]);

  if (browser) {
    switch (browser.name) {
      case 'ie':
        return false;
      case 'chrome':
        return formattedBrowserVersion >= 76;
      case 'safari':
        return formattedBrowserVersion >= 10;
      case 'firefox':
        return formattedBrowserVersion >= 52;
      default:
        return true;
    }
  }
}

export default isSupportedSlateBrowser;
